import { createAsyncThunk } from '@reduxjs/toolkit';

import { AICoachConversationApi, AiCoachTurnResult } from 'api/AICoachConversationApi';
import { RootState } from 'handlers';

import { ErrorResponse } from './ErrorResponse';

export interface PostCoachConversationThunkParams {
  appId: string;
  optionId?: string;
}

export const createPostCoachConversationThunk = (api: AICoachConversationApi) =>
  createAsyncThunk(
    'aiCoachConversation/postCoachConversation',
    async ({ appId, optionId }: PostCoachConversationThunkParams, thunkApi) => {
      try {
        const { aiCoachConversation } = thunkApi.getState() as RootState;
        const sessionState = aiCoachConversation.sessionState ?? undefined;

        const result: AiCoachTurnResult = await api.postCoachConversation({
          appId,
          state: optionId === undefined ? undefined : sessionState,
          optionId,
        });

        return result;
      } catch (error: unknown) {
        return thunkApi.rejectWithValue((error as ErrorResponse)?.response?.data);
      }
    },
  );
